module.exports = __webpack_public_path__ + "static/assets/ethan-jameson-RtyniRlSatw-unsplash1.c64353c3.jpg";